var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-card',{attrs:{"title":_vm.$t('tables.loading')}},[_c('va-data-table',{attrs:{"fields":_vm.fields,"data":_vm.users,"loading":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }